import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import InputSliders from '../InputSlider/InputSlider';
import './Filters.css';

const Filters = ({ filters, maxAvailSqFt, options, handleChange }) => (
    <div className="columns filters-wrapper">
        <div className="column is-narrow-desktop">
            <Select
                className="select-wrapper"
                classNamePrefix="react-select"
                placeholder="Region"
                name="region"
                instanceId="filter-region"
                options={options.regions.filter(option => !option.isDisabled)}
                value={filters.region}
                isSearchable={false}
                onChange={({ value, label }) => handleChange('region', value, label)}
            />
        </div>
        <div className="column is-narrow-desktop">
            <Select
                className="select-wrapper"
                classNamePrefix="react-select"
                placeholder="Submarket"
                name="subMarket"
                instanceId="filter-subMarket"
                options={options.subMarkets.filter(option => !option.isDisabled)}
                value={filters.subMarket}
                isSearchable={false}
                onChange={({ value, label, region }) => handleChange('subMarket', value, label, region)}
            />
        </div>
        <div className="column is-narrow-desktop">
            <Select
                className="select-wrapper"
                classNamePrefix="react-select"
                placeholder="Type"
                name="projectType"
                instanceId="filter-projectType"
                options={options.projectTypes.filter(option => !option.isDisabled)}
                value={filters.projectType}
                isSearchable={false}
                onChange={({ value, label }) => handleChange('projectType', value, label)}
            />
        </div>
        <div className="column is-narrow-desktop">
            <Select
                className="select-wrapper"
                classNamePrefix="react-select"
                placeholder="Total Sq Ft"
                name="totalSqFt"
                instanceId="filter-totalSqFt"
                options={options.totalSqFts.filter(option => !option.isDisabled)}
                value={filters.totalSqFt}
                isSearchable={false}
                onChange={({ value, label }) => handleChange('totalSqFt', value, label)}
            />
        </div>
        {/* <div className={`column slider-wrapper ${filters.availableSqFt === null ? '' : 'active'}`}>
            <div className="columns vertical-align-middle is-desktop">
                <div className="column is-narrow-desktop">
                    <label className="filter-label" htmlFor="availableSqFt">Available Sq. Ft.</label>
                </div>
                <InputSliders filters={filters} maxAvailSqFt={maxAvailSqFt} handleChange={handleChange} />
            </div>
        </div> */}
    </div>
);

Filters.propTypes = {
    filters: PropTypes.shape({
        region: PropTypes.shape({
            label: PropTypes.string,
        }),
        subMarket: PropTypes.shape({
            label: PropTypes.string,
        }),
        projectType: PropTypes.shape({
            label: PropTypes.string,
        }),
        totalSqFt: PropTypes.shape({
            label: PropTypes.string,
        }),
        availableSqFt: PropTypes.shape({
            values: PropTypes.shape({
                min: PropTypes.number,
                max: PropTypes.number,
            }),
        }),
    }).isRequired,
    options: PropTypes.shape({
        regions: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool.isRequired,
        })),
        subMarket: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool.isRequired,
        })),
        projectType: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool.isRequired,
        })),
        totalSqFt: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool.isRequired,
        })),
        subMarkets: PropTypes.array,
        projectTypes: PropTypes.array,
        totalSqFts: PropTypes.array,
    }).isRequired,
    maxAvailSqFt: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default Filters;
